import { AI_GENERATE_DOCK_QUIZ_TYPES } from '../consts/aiGenerateDock.const';
import {
  type AiGenerateDockConditions,
  type AiGenerateDockCopy,
} from '../types/aiGenerateDock.types';

/**
 * 한 줄 요약 — 「10 · 선택형 +1 · 섞기」. 좁은 화면 시트 버튼의 접근 이름에 쓴다(넓은 화면은 칩 3개가 값을 보인다).
 * 문제 수는 숫자만, 유형이 여러 개면 첫 유형 + 「+N」, 난이도는 기본값(섞기)이어도 항상 붙인다.
 */
export const formatAiGenerateDockConditionsSummary = (
  copy: AiGenerateDockCopy,
  conditions: AiGenerateDockConditions,
  count: number,
) => {
  const [first, ...rest] = AI_GENERATE_DOCK_QUIZ_TYPES.filter(type =>
    conditions.quizTypes.includes(type),
  ).map(type => copy.quizTypes[type]);
  const types = first && rest.length > 0 ? `${first} +${rest.length}` : first;
  return [String(count), types, copy.difficulties[conditions.difficulty]]
    .filter(Boolean)
    .join(' · ');
};
